import { render } from "./PremiumChoice.vue?vue&type=template&id=03572939"
import script from "./PremiumChoice.vue?vue&type=script&lang=js"
export * from "./PremiumChoice.vue?vue&type=script&lang=js"

import "./PremiumChoice.vue?vue&type=style&index=0&id=03572939&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__